import { cn } from "tools/ui";

const styleBase = "grid grid-cols-2 gap-x-2 w-full h-fit";

function PanelSide({ widget, children, stylePanel }) {
  const style = stylePanel ?? styleBase;
  const width = widget.width ?? "w-1/2";
  return (
    <div id={widget.name} key={widget.name} className={cn(width, style)}>
      {children}
    </div>
  );
}

export default PanelSide;
